export default __webpack_public_path__ + "static/media/mappa.92cfc85c.jpg";